const serviceGroups = [
  {
    title: "Plans",
    icon: "plans",
    items: [
      {
        label: "Traffic Management Plans",
        slug: "traffic-management-plans",
        icon: "plans",
        subtitle:
          "A clear, compliant plan for how traffic, pedestrians and cyclists will move around your work, prepared for council and road authority approval.",
        sections: [
          {
            heading: "What Is a Traffic Management Plan?",
            body: "A Traffic Management Plan (TMP) sets out how people and vehicles will be kept safe while work is underway. It covers the work zone, signs and devices, staging, responsibilities and what happens if conditions change. Most councils and road authorities want one before they will issue a permit.",
          },
          {
            heading: "What We Prepare",
            body: "We write the plan around your actual job: where the work sits, how long it runs, which roads and footpaths it touches, and how trucks, workers and the public will get through. Diagrams, risk notes and the procedures your crew will follow are included so the document can go in with the permit application.",
          },
          {
            heading: "Who It Is For",
            body: "Builders, utilities, councils, event organisers and maintenance crews use a TMP whenever work affects a public road, footpath or parking area. We prepare plans for metro, regional and rural sites across Australia.",
          },
        ],
        features: [
          "Site-specific plan, not a generic template",
          "Aligned with AS 1742.3 and local authority rules",
          "Covers vehicles, pedestrians and cyclists",
          "Ready to lodge with the permit application",
          "Revisions if the authority asks for changes",
          "Most plans turned around within 24 hours",
        ],
      },
      {
        label: "Construction Traffic Management Plans",
        slug: "construction-traffic-management-plans",
        icon: "building",
        subtitle:
          "Comprehensive, compliant traffic management plans for construction projects of all sizes, prepared by qualified professionals and ready for authority approval.",
        sections: [
          {
            heading: "What Is a Construction TMP?",
            body: "A Construction Traffic Management Plan (TMP) is a document that sets out how traffic, pedestrians and cyclists will be safely managed around a construction site. It covers signage, traffic control devices, lane configurations, haulage routes and risk management, and is typically required before a council or authority will issue permits for your works.",
          },
          {
            heading: "Our Approach",
            body: "We work closely with your site team to understand the scope and constraints of your project before preparing a tailored TMP. Every plan is prepared in accordance with the relevant Australian Standards and Transport for NSW requirements, and is structured to get through the approval process with minimal back-and-forth.",
          },
          {
            heading: "Suitable For",
            body: "Our construction TMPs are suitable for residential builds, commercial developments, infrastructure projects, utility works, road maintenance and any other construction activity that affects or is near a public road.",
          },
        ],
        features: [
          "Compliant with AS 1742.3 and TfNSW guidelines",
          "Site-specific plans tailored to your project",
          "Includes traffic guidance scheme diagrams",
          "Covers pedestrian and cyclist management",
          "Authority submission handled on request",
          "Delivered within 24 hours for most projects",
        ],
      },
      {
        label: "Traffic Control Plans / Traffic Guidance Schemes",
        slug: "traffic-guidance-scheme",
        icon: "signs",
        subtitle:
          "Clear, compliant traffic guidance scheme diagrams prepared by qualified professionals and ready for council and authority approval on the first submission.",
        sections: [
          {
            heading: "What Is a Traffic Guidance Scheme?",
            body: "A Traffic Guidance Scheme (TGS) is a detailed diagram that shows the exact placement of signs, cones, barriers, lane configurations and any other traffic control devices required for a specific work site. It forms a critical part of your traffic management documentation and must comply with AS 1742.3 and relevant authority requirements.",
          },
          {
            heading: "Why Quality Matters",
            body: "A poorly prepared TGS is one of the most common causes of permit rejections and project delays. Our schemes are drawn to scale, clearly annotated and prepared in strict accordance with the latest Australian Standards and Transport for NSW guidelines, giving your application the best chance of first-time approval.",
          },
          {
            heading: "What We Cover",
            body: "We prepare TGS diagrams for all types of work sites, including lane closures, intersection works, footpath occupancies, road closures, night works and multi-stage projects. Each scheme is tailored to your specific site conditions and scope of works.",
          },
        ],
        features: [
          "Compliant with AS 1742.3",
          "Drawn to scale with full annotation",
          "All site types and road classifications",
          "Night works and multi-stage schemes",
          "Suitable for TfNSW and council submission",
          "Fast delivery, with most schemes within 24 hours",
        ],
      },
      {
        label: "Pedestrian Control Plans",
        slug: "pedestrian-control-plans",
        icon: "pedestrian",
        subtitle:
          "Keeping pedestrians safe around your work site is a legal requirement. We prepare detailed pedestrian control plans that comply with all relevant standards and are approved by authorities first time.",
        sections: [
          {
            heading: "What Is a Pedestrian Control Plan?",
            body: "A Pedestrian Control Plan (PCP) is a document that details how pedestrian movement will be safely managed around a work site or road closure. It includes alternative pathways, hoarding arrangements, temporary crossing points, signage and lighting requirements, and forms part of your broader traffic management documentation.",
          },
          {
            heading: "Legal Requirements",
            body: "Under the Work Health and Safety Act and relevant road authority guidelines, all works that affect pedestrian access on public roads or footpaths must be accompanied by a pedestrian management plan. Failure to have one in place exposes your project to stop-work orders, fines and significant liability.",
          },
          {
            heading: "Our Process",
            body: "We conduct a desktop review of your site location, review council and authority requirements, and produce a compliant pedestrian control plan ready for submission. For complex sites, we offer site visits to ensure the plan is accurate and practical for your team to implement.",
          },
        ],
        features: [
          "Compliant with AS 1742.10 and local council requirements",
          "Alternative pedestrian pathway diagrams",
          "Temporary crossing and hoarding layouts",
          "Signage and lighting specifications",
          "Integrated with your TMP or TGS",
          "Suitable for CBD, suburban and regional sites",
        ],
      },
      {
        label: "Road Closure & Detour Plans",
        slug: "road-closure-detour-plans",
        icon: "closure",
        subtitle:
          "Full or partial road closures require precise planning and authority approval. We prepare everything you need, from the closure layout to the detour route, and manage the submission process on your behalf.",
        sections: [
          {
            heading: "When Is a Road Closure Plan Required?",
            body: "A road closure plan is required whenever works necessitate the full or partial closure of a public road, lane or intersection. This includes utility works, bridge maintenance, large construction activities, events and emergency situations. Both planned and emergency closures require documentation to be in place before or shortly after the closure occurs.",
          },
          {
            heading: "What We Prepare",
            body: "We prepare a complete road closure package including the closure layout diagram, alternative detour route plan, public notification requirements, traffic guidance scheme for the closure zone, and any supporting documentation required by the relevant road authority or council.",
          },
          {
            heading: "Authority Submissions",
            body: "We handle all submissions to Transport for NSW, local councils and other relevant authorities. Our team tracks the approval status and manages any queries or revision requests so your project isn't delayed waiting for paperwork.",
          },
        ],
        features: [
          "Full and partial road closure layouts",
          "Detour route design and diagrams",
          "Public notification documentation",
          "TfNSW and council submissions managed",
          "Emergency closure support available",
          "24/7 urgent request handling",
        ],
      },
      {
        label: "Event / Parade Traffic Management Plans",
        slug: "event-parade-traffic-management-plans",
        icon: "event",
        subtitle:
          "Traffic plans for parades, street festivals, fun runs and filming, so the event can go ahead with a safe route for the crowd, the participants and everyone still trying to get through.",
        sections: [
          {
            heading: "What the Plan Covers",
            body: "An event traffic management plan sets out the route or site, when roads close and reopen, where spectators stand, how emergency vehicles get in, and how local traffic is detoured. It is usually required before police, council or the road authority will approve the event.",
          },
          {
            heading: "Built Around the Event",
            body: "We work from your run sheet: bump-in, the event itself and bump-out. The plan covers marshals, temporary fencing, pedestrian crossings, public transport stops that are affected, and the signs the public will see on the way in.",
          },
          {
            heading: "Approvals",
            body: "Event traffic often needs more than one sign-off. We prepare the drawings and written plan so they can go to council, police and the road authority together, and we revise them if an authority asks for a change to the route or the timing.",
          },
        ],
        features: [
          "Parade, festival, market and filming plans",
          "Closure times matched to the run sheet",
          "Spectator, participant and local traffic separated",
          "Emergency access kept clear",
          "Detours and public notifications included",
          "Prepared for council and police lodgement",
        ],
      },
    ],
  },
  {
    title: "Permits",
    icon: "permits",
    items: [
      {
        label: "Council Permits",
        slug: "council-permits",
        icon: "council",
        subtitle:
          "We handle the full permit submission process on your behalf, ensuring your application meets all local council requirements and is approved without delays.",
        sections: [
          {
            heading: "What Are Council Permits?",
            body: "A council permit (also known as a road occupancy licence or works zone permit) is required any time work is carried out that affects a public road, footpath or parking area within a local government area. Most construction, utility and maintenance works will require one before work can begin.",
          },
          {
            heading: "What We Do",
            body: "Our team prepares and submits all council permit documentation on your behalf. This includes traffic management plans, traffic guidance schemes, notification letters and any supporting drawings required by the council. We liaise directly with council officers to manage the approval process from lodgement to sign-off.",
          },
          {
            heading: "Why Choose Us?",
            body: "We have extensive experience working with councils across New South Wales and beyond. Our familiarity with each council's specific requirements means fewer rejections, faster approvals and less stress for your team.",
          },
        ],
        features: [
          "Application preparation and lodgement",
          "Traffic management plan included",
          "Direct council liaison",
          "Revision management if required",
          "NSW-wide coverage",
          "Fast turnaround, often within 24 hours",
        ],
      },
      {
        label: "Police Permits",
        slug: "police-permits",
        icon: "police",
        subtitle:
          "When police have to approve the traffic arrangements, we prepare the documents they ask for and follow the application through to sign-off.",
        sections: [
          {
            heading: "When Police Approval Is Needed",
            body: "Police are usually involved when an event, parade or road closure changes how traffic moves, or when works need a police presence. Their approval sits alongside the council or road authority permit. One does not replace the other.",
          },
          {
            heading: "What We Lodge",
            body: "We prepare the traffic plan, closure or detour drawings, timing and the written description police need to assess the job. The pack is written so an officer who has not seen the site can understand the route, the risks and how they will be managed.",
          },
          {
            heading: "Follow-through",
            body: "We lodge the application, answer questions and revise the plan if police want a change to timing, marshal positions or the detour. You get a clear record of what was approved before the day of the job.",
          },
        ],
        features: [
          "Event and works applications",
          "Traffic plan written for police review",
          "Timing, route and marshal details included",
          "Questions and revisions handled",
          "Sits with your council or road authority permit",
          "Urgent jobs accepted around the clock",
        ],
      },
      {
        label: "RMS ROLS and Approvals",
        slug: "rms-rols-and-approvals",
        icon: "approval",
        subtitle:
          "Road occupancy licences and related Transport for NSW approvals for works on the state road network, lodged through ROLS.",
        sections: [
          {
            heading: "What ROLS Is For",
            body: "Works on a state road, such as a lane closure, a shoulder occupancy, a crane on the road, or a temporary speed change, generally need a Road Occupancy Licence. Applications go through the Road Occupancy Licence System, still widely called RMS ROLS, which is run by Transport for NSW.",
          },
          {
            heading: "What We Prepare",
            body: "We put together the traffic guidance scheme, the occupancy details, the times you need the road and any supporting plans the reviewer will ask for. The application is filled out against the road, the direction and the work method, not copied from a previous job.",
          },
          {
            heading: "Approvals Beside the Licence",
            body: "Some jobs also need a speed zone authorisation, a road opening approval or agreement from another part of Transport for NSW. We identify those early and include them in the same pack so the licence is not held up waiting on a second document.",
          },
        ],
        features: [
          "Road Occupancy Licence applications",
          "Lodged through ROLS",
          "Traffic guidance scheme for the occupancy",
          "Lane, shoulder and intersection works",
          "Related Transport for NSW approvals identified",
          "Revisions managed if the reviewer asks",
        ],
      },
      {
        label: "Bus Approvals",
        slug: "bus-approvals",
        icon: "bus",
        subtitle:
          "Approvals for works that move a bus stop, occupy a bus lane or change how passengers reach a service.",
        sections: [
          {
            heading: "When a Bus Approval Is Required",
            body: "If your work closes a bus stop, blocks a bus lane, or sends passengers on a longer walk, the bus operator and Transport for NSW usually have to agree before you start. Turning up without that approval is a common reason for a job to be stood down.",
          },
          {
            heading: "What We Arrange",
            body: "We draw the temporary stop, the passenger walking route, the signs drivers and the public will see, and the times the change applies. The pack is written for the operator reviewing it, with the existing stop, the proposed stop and the way back to the normal arrangement.",
          },
          {
            heading: "Tied to the Rest of the Plan",
            body: "Bus approvals are prepared with the traffic management plan and the traffic guidance scheme, so the stop relocation, the lane closure and the pedestrian path all describe the same site.",
          },
        ],
        features: [
          "Temporary bus stop relocations",
          "Bus lane and bus zone impacts",
          "Passenger walking routes and signs",
          "Operator and Transport for NSW lodgement",
          "Matched to the TMP and traffic guidance scheme",
          "Reinstatement of the normal stop included",
        ],
      },
    ],
  },
  {
    title: "Site works",
    icon: "site",
    items: [
      {
        label: "Site Planning and Location Planning",
        slug: "site-planning-and-location-planning",
        icon: "pin",
        subtitle:
          "A practical read of the site before the plan is drawn, covering access, constraints and where the work should sit so the traffic measures will actually fit.",
        sections: [
          {
            heading: "What We Look At",
            body: "Before a traffic plan is useful, someone has to understand the place: driveways, bus stops, sight lines, school zones, narrow lanes, loading docks and where plant can stand. Site and location planning is that assessment, written up so the later drawings follow it.",
          },
          {
            heading: "How It Is Used",
            body: "We mark the workable positions for the work zone, compound, truck standing and pedestrian diversion, and we note the constraints that will shape the permit. That gives your team and the authority the same picture of how the job occupies the street.",
          },
          {
            heading: "When to Ask for It",
            body: "It is most useful early, while the methodology can still move. Builders use it to choose a crane position or a site gate. Utilities use it to pick which side of the road a trench should run.",
          },
        ],
        features: [
          "Desktop review of the site and network",
          "Work zone, access and standing positions",
          "Constraints called out before design is locked",
          "Feeds the TMP and traffic guidance scheme",
          "Site visit available on complex jobs",
          "Useful at tender and before lodgement",
        ],
      },
      {
        label: "Vehicle Movement Plans",
        slug: "vehicle-movement-plans",
        icon: "truck",
        subtitle:
          "Plans that show how trucks and plant enter, move around and leave the site without conflicting with pedestrians, neighbours or through traffic.",
        sections: [
          {
            heading: "What a Vehicle Movement Plan Shows",
            body: "A vehicle movement plan traces the path of heavy vehicles from the public road to the work area and back out. It covers arrival, circulation, standing, unloading and departure, and it separates those movements from pedestrians and light vehicles where the site allows it.",
          },
          {
            heading: "Why Authorities Ask for One",
            body: "Councils and road authorities want to see that trucks can make the turn, that they will not queue back onto a through lane, and that reversing is avoided or controlled. A movement plan is often a condition of a construction certificate or a road permit on busier sites.",
          },
          {
            heading: "What We Deliver",
            body: "We draw the routes for the vehicles you actually use, note the controls at the gate, and flag any turn that needs a swept path check or a traffic controller. The plan can stand alone or sit inside the construction traffic management plan.",
          },
        ],
        features: [
          "Entry, circulation and exit routes",
          "Truck standing and unloading positions",
          "Conflict points with pedestrians marked",
          "Sized to the vehicles on the job",
          "Suitable for council submission",
          "Can include a swept path check",
        ],
      },
      {
        label: "Crane & Concrete Traffic Plans",
        slug: "crane-concrete-traffic-plans",
        icon: "crane",
        subtitle:
          "Short-duration traffic plans for crane lifts and concrete pours, covering the road and footpath while the truck, pump or crane is in place.",
        sections: [
          {
            heading: "Why These Jobs Need Their Own Plan",
            body: "A crane lift or a concrete pour often occupies the kerb, a lane or the footpath for a few hours, with a queue of trucks that the everyday site plan never showed. Authorities treat that occupancy as its own activity and expect a plan that matches the lift or the pour, not the whole build.",
          },
          {
            heading: "What the Plan Includes",
            body: "We set out the crane or pump position, the exclusion zone, where trucks stand and depart, how pedestrians get past, and the signs and devices for the duration of the work. If the lift needs a road occupancy licence, the drawing is prepared so it can go in with that application.",
          },
          {
            heading: "Timing",
            body: "These jobs move quickly. We prepare the plan against the booked date and the plant you have confirmed, and we can revise it if the pour time or the crane size changes before the day.",
          },
        ],
        features: [
          "Crane lift and concrete pour layouts",
          "Truck queue and departure paths",
          "Exclusion zones and pedestrian detours",
          "Matched to the booked plant and time",
          "Ready for a road occupancy application",
          "Short-notice turnaround available",
        ],
      },
      {
        label: "Mobile Work Traffic Control Plans",
        slug: "mobile-work-traffic-control-plans",
        icon: "mobile",
        subtitle:
          "Traffic control plans for works that move along the road, including line marking, surveying, inspection and maintenance, rather than a site that stays in one place.",
        sections: [
          {
            heading: "What Counts as Mobile Work",
            body: "Mobile work travels with the crew. The signs, the shadow vehicle and the work vehicle shift as the job moves, so a fixed site diagram does not describe it. AS 1742.3 sets out how those moving operations are signed and how far the advance warning sits from the work.",
          },
          {
            heading: "What We Draw",
            body: "The plan shows the order of vehicles, the signs on each, the taper or work position, and how the arrangement changes between a shoulder, a lane and an intersection. It gives the crew one drawing they can apply as they travel, including the points where the method has to change.",
          },
          {
            heading: "Typical Jobs",
            body: "Line marking, road inspection, surveying, vegetation control, pavement testing and short maintenance stops. If the work sometimes stops and becomes a static site, we include that arrangement as well.",
          },
        ],
        features: [
          "Prepared against AS 1742.3 mobile works",
          "Vehicle order and sign layout",
          "Advance warning distances set out",
          "Shoulder, lane and intersection cases",
          "Static fallback where the work stops",
          "Suitable for authority submission",
        ],
      },
      {
        label: "VMS and Advanced Warning Traffic Management Plans",
        slug: "vms-advanced-warning-traffic-management-plans",
        icon: "vms",
        subtitle:
          "Plans for variable message signs and the advance warning drivers need before they reach a closure, detour or change in conditions.",
        sections: [
          {
            heading: "What Advance Warning Does",
            body: "Drivers need time to change lanes, leave the motorway or slow down. Advance warning, using fixed signs and variable message signs, is how that message is given, at a distance that matches the speed of the road. Putting a sign in the wrong place, or with the wrong message, is a frequent reason an authority sends a plan back.",
          },
          {
            heading: "What We Specify",
            body: "We set the sign locations, the face layout and the message for each stage of the job: upcoming works, the closure itself and the detour. For variable message signs we write the frames so they fit the sign and say one thing at a time.",
          },
          {
            heading: "Where It Sits",
            body: "The advance warning plan is prepared with the traffic guidance scheme, so the signs on the approach and the devices at the work zone tell the same story. It is used for planned lane closures, long-term works and events that affect a main road.",
          },
        ],
        features: [
          "Variable message sign locations and frames",
          "Advance warning distances for the road speed",
          "Messages for each stage of the works",
          "Approach signs matched to the site scheme",
          "Detour and closure wording",
          "Prepared for Transport for NSW and council review",
        ],
      },
      {
        label: "Site Meetings and Investigations for Traffic Measures",
        slug: "site-meetings-and-investigations",
        icon: "meeting",
        subtitle:
          "A planner on site, or in the meeting, to check that the traffic measures match the street and the way the job will actually be built.",
        sections: [
          {
            heading: "Why a Desktop Plan Is Not Always Enough",
            body: "Photos and maps miss a new driveway, a temporary hoist, a bus stop that moved, or a sight line blocked by a hoarding. A site investigation checks the measures against what is there, before the plan is lodged or before the crew sets up.",
          },
          {
            heading: "Site Meetings",
            body: "We attend project and authority meetings to talk through staging, haul routes, crane days and pedestrian paths. The notes come back into the plan, so the document the council sees is the one the site agreed.",
          },
          {
            heading: "What You Receive",
            body: "You get the findings in writing: what has to change on the drawing, what can stay, and any constraint that will affect the permit. Where a revision is needed, we update the plan from the same visit.",
          },
        ],
        features: [
          "On-site review of proposed measures",
          "Attendance at project and authority meetings",
          "Conflicts with the built street recorded",
          "Findings written back into the plan",
          "Useful before lodgement or before setup",
          "Available across metro and regional sites",
        ],
      },
    ],
  },
  {
    title: "Project support",
    icon: "support",
    items: [
      {
        label: "Aftercare Traffic Management Plans",
        slug: "aftercare-traffic-management-plans",
        icon: "aftercare",
        subtitle:
          "Traffic plans for the period after the main works, when the road is not yet back to normal and smaller crews are still on site.",
        sections: [
          {
            heading: "What Aftercare Covers",
            body: "After the main construction, a road can still have a reduced surface, a temporary line marking layout, open defects or a lower speed. The aftercare plan describes the traffic measures for that period, including how maintenance and defect crews will occupy the road.",
          },
          {
            heading: "Why the Construction Plan Does Not Cover It",
            body: "The construction TMP is written for the build: large plant, long closures, a full crew. Aftercare is quieter and often mobile, and authorities expect the measures to be scaled to that. Using the construction drawing after the site has demobilised leaves the crew with devices they do not need and gaps where they do.",
          },
          {
            heading: "What We Prepare",
            body: "We prepare a plan and scheme for the remaining hazards and the typical maintenance visit, and we note the trigger for going back to a full closure if a defect repair needs it. It can be lodged as its own approval or as a stage of the project plan.",
          },
        ],
        features: [
          "Plans for the defects and maintenance period",
          "Measures scaled down from the construction stage",
          "Temporary surfaces and reduced speeds covered",
          "Mobile and short-stop arrangements",
          "Trigger for a full closure if a repair needs it",
          "Can be lodged as its own stage",
        ],
      },
      {
        label: "Major Project Planning",
        slug: "major-project-planning",
        icon: "project",
        subtitle:
          "Traffic planning for large, multi-stage projects: one strategy for the whole job, with a plan for each stage that has to be built.",
        sections: [
          {
            heading: "More Than a Single Drawing",
            body: "A major project moves. Haul roads change, intersections are rebuilt in stages, and neighbouring contracts occupy the same corridor. A single site plan cannot describe that. Major project planning sets the traffic strategy first, then the plans for each stage.",
          },
          {
            heading: "What We Produce",
            body: "We map the stages, the long-term closures, the haul routes and the points where the public, buses and site traffic conflict. Each stage gets a traffic management plan and the schemes it needs, written so the crew can see what changes when the stage changes.",
          },
          {
            heading: "Working With the Project Team",
            body: "We sit with the planners, the construction team and the authority reviewers. Staging assumptions are checked before they are drawn, which keeps late redraws out of the program.",
          },
        ],
        features: [
          "Corridor and staging strategy",
          "A plan for each construction stage",
          "Haul routes and long-term closures",
          "Bus, pedestrian and site traffic separated",
          "Coordination with authority reviewers",
          "Updates as the staging changes",
        ],
      },
      {
        label: "Traffic Flow Reporting",
        slug: "traffic-flow-reporting",
        icon: "report",
        subtitle:
          "Written reports on how traffic is moving through a work site or corridor, covering volumes, queues and delays before and during the job.",
        sections: [
          {
            heading: "What the Report Is For",
            body: "Authorities and project teams ask for a traffic flow report when they need evidence, not just a drawing. It records how many vehicles are using a road, where they queue, and how a closure or a detour changes that.",
          },
          {
            heading: "What We Measure",
            body: "Depending on the brief, we use counts, observations and the approved layout to describe peak periods, queue length, diversion routes and any movement that is not performing as the plan assumed. The findings are written so a reviewer who was not on site can follow them.",
          },
          {
            heading: "How It Is Used",
            body: "Reports support a permit application, a change to staging, or a review after complaints. They also give the project team a baseline, so later stages can be compared with how the road behaved before the work.",
          },
        ],
        features: [
          "Volumes, queues and delay described in writing",
          "Before and during comparisons",
          "Tied to the approved traffic layout",
          "Written for authority reviewers",
          "Supports a permit or a staging change",
          "Baseline for later stages of the project",
        ],
      },
      {
        label: "Road Work Analysis",
        slug: "road-work-analysis",
        icon: "analysis",
        subtitle:
          "A review of proposed or existing road works, looking for traffic conflicts, staging problems and gaps before they hold up an approval.",
        sections: [
          {
            heading: "What We Review",
            body: "We read the methodology, the staging and the drawings already produced, and we compare them with the road they will be built on. The analysis looks for conflicts between stages, missing pedestrian routes, haul roads that do not fit, and measures that fall short of the standard the authority will apply.",
          },
          {
            heading: "What You Get",
            body: "A written list of the issues, which ones will affect approval, and what to change. Where a drawing needs to be redone, we can revise it or prepare the missing plan as a follow-on.",
          },
          {
            heading: "When It Helps",
            body: "It is used at tender, when a methodology is still moving, and when an authority has already sent a submission back. It is also used mid-project when the next stage no longer matches the plan that was approved.",
          },
        ],
        features: [
          "Review of methodology and staging",
          "Conflicts and missing measures listed",
          "Checked against the road and the standard",
          "Written findings, ordered by impact",
          "Revisions available as a follow-on",
          "Useful at tender and after a rejection",
        ],
      },
      {
        label: "Swept Path Analysis",
        slug: "swept-path-analysis",
        icon: "swept",
        subtitle:
          "Vehicle turning checks for driveways, intersections, loading docks and work sites, using the vehicles that will actually make the turn.",
        sections: [
          {
            heading: "What a Swept Path Shows",
            body: "A swept path is the area a vehicle covers as it turns, including the body and the overhang. The analysis draws that path over the design or the existing road to show whether a truck, bus or crane can enter, turn and leave without mounting a kerb, hitting a structure or swinging into the opposing lane.",
          },
          {
            heading: "The Vehicles We Test",
            body: "We use the design vehicles that match the job, from a service truck or a garbage truck up to an articulated vehicle, a bus or a crane, based on Austroads templates and the fleet you nominate. Checking the wrong vehicle is the usual reason a site gate fails on the first delivery.",
          },
          {
            heading: "Where It Is Used",
            body: "Site entries, basement ramps, loading docks, temporary intersections and detours. The drawing can support a development application, a construction plan or a vehicle movement plan, and it marks the changes needed if the turn does not fit.",
          },
        ],
        features: [
          "Turns drawn for the nominated vehicles",
          "Austroads design vehicle templates",
          "Site entries, docks, ramps and detours",
          "Conflicts with kerbs, lanes and structures marked",
          "Supports a DA or a vehicle movement plan",
          "Changes noted where the turn does not fit",
        ],
      },
    ],
  },
];

for (const group of serviceGroups) {
  for (const item of group.items) {
    item.to = `/services/${item.slug}`;
  }
}

export { serviceGroups };

export const allServices = serviceGroups.flatMap((group) => group.items);

export function findService(slug) {
  return allServices.find((item) => item.slug === slug) || null;
}
